<template>
  <template v-if="Array.isArray(recommend) && recommend.length">
    <div v-if="store.state.base.responsive.isMD">
      <ul v-for="recommend_item in recommend" :key="recommend_item.id" class="card-outlined p-4 my-2">
        <li class="px-1 pt-1.5 pb-2">
          <div @click="openSalesPage(recommend_item.sales_url)" class="flex justify-center hover:opacity-75 cursor-pointer">
            <div class="w-full">
              <div class="aspect-w-16 aspect-h-9">
                <img loading="lazy" :src="recommend_item.thumbnail_url" alt="thumbnail" class="w-full">
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div v-else>
      <ul v-for="recommend_item in recommend" :key="recommend_item.id" class="card-outlined py-2 px-4 my-4">
        <li class="px-1 pt-1.5 pb-2">
          <div @click="openSalesPage(recommend_item.sales_url)" class="flex items-center justify-start hover:opacity-75 cursor-pointer">
            <div class="min-w-[20rem]">
              <div class="aspect-w-16 aspect-h-9">
                <img width="100%" height="100%" loading="lazy" :src="recommend_item.thumbnail_url" alt="thumbnail">
              </div>
            </div>
            <div class="ml-5 mt-2">
              <h2 class="text-3xl font-serif">{{recommend_item.title}}</h2><br>
              <div class="font-serif px-1" style="white-space:pre-wrap; word-wrap:break-word;">{{recommend_item.body}}</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </template>
  <template v-else>
    現在受講できる講座はありません。新しい情報をお待ちください。
  </template>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue'
import { useStore } from '@/store/index'
import { axios, ApiResponse } from '@/plugins/axios'
import { RecommendAttributes } from '@/types/models/recommend-course'

export default defineComponent({
  setup() {
    const store = useStore()
    const recommend = ref<RecommendAttributes | undefined>()

    onMounted(() => {
      axios
        .get<ApiResponse<RecommendAttributes>>('course/recommend')
        .then(response => {
          recommend.value = response.data.payload
        })
    })

    const openSalesPage = (sales_url:string) => {
      window.open(sales_url, '_blank')
    }

    return {
      store,
      recommend,
      openSalesPage
    }
  }
})
</script>
